<template>
    <div class="vue timparty-rewards-tiers band-rewards-tiers">
      <div v-if="isEnabled" class="bg-dark">
        <div class="container px-0 py-md-3">

          <div class="row">
            <div class="col-sm-6">
              <div class="p-3" :style="'border: 1px solid ' + user.cluster_color" >

                <div class="row no-gutters">
                  <div class="col-3 col-md-2 d-flex align-items-center">
                    <img class="img-cluster img-fluid" :src="user.cluster_image">
                  </div>
                  <div class="col-7 col-md-10 d-flex align-items-center">
                    <div class="w-100">
                      <div class="row">
                        <div class="col-sm-8 d-flex align-items-center">
                          <div class="h5">SEI <span class="font-weight-bold" :style="'color: ' + user.cluster_color + ' !important;'">CLIENTE {{ user.cluster_name }}</span></div>
                        </div>
                        <div class="col-sm-4 d-flex align-items-center justify-items-end">
                          <div class="text-md-center w-100">
                            <a :href="currentTierUrl" class="current-tier-url  btn btn-sm btn-white">SCOPRI I VANTAGGI</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-2 col-md-0 d-flex align-items-center">
                    <a class="mobile-toggler d-md-none p-3" href="#" @click.prevent="mobile_visible = !mobile_visible">
                      <img v-if="!mobile_visible" :src="modulePath('/js/src/assets/images/icon-boxed-arrow-up.svg')">
                      <img v-if="mobile_visible" :src="modulePath('/js/src/assets/images/icon-boxed-arrow-down.svg')">
                    </a>
                  </div>
                </div>
              </div>

            </div>
            <div :class="'d-md-block col-sm-6 ' + ( mobile_visible ? '' : 'd-none')">
              <div class="p-3 " :style="'border: 1px solid ' + lastCluster.color">

                <div class="row">
                  <div class="col-3 col-md-2 d-flex align-items-center">
                    <img class="img-cluster next" :src="lastCluster.image">
                  </div>
                  <div class="col-9 col-md-10 d-flex align-items-center">
                    <div class="w-100">
                      <div class="row">
                        <div class="col-sm-8 d-flex align-items-center">
                          <div class="h5 ">DIVENTA <span class="font-weight-bold" :style="'color: ' + lastCluster.color + ' !important;'">CLIENTE {{ lastCluster.name }}</span></div>
                        </div>
                        <div class="col-sm-4 d-flex align-items-center justify-items-end">
                          <div class="text-md-center w-100">
                            <a class="next-tier-url  btn btn-sm btn-white" :href="nextTierUrl">Scopri i vantaggi</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>








              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
</template>

<script>

    /* eslint-disable */

    import TimPartyMixin from '../mixins/TimPartyMixin';
    import $ from 'jquery';

    export default {
      name: 'BandRewardsTiers',
      mixins: [ TimPartyMixin ],
      props: {
        currentTierUrl:{
          required: false,
          default: '/vantaggi',
        },
        nextTierUrl:{
          required: false,
          default: '#fisso-mobile',
        },

      },
      data: function(){

        return {
          mobile_visible: false,
        };
      },
      mounted: function(){

      },

      methods: {

      },
      computed: {
        isEnabled: function(){
          return ( this.user.cluster && this.user.cluster != 'GUEST_STAR');
        },
        lastCluster: function(){
          if(this.user.clusters != undefined && this.user.clusters.length > 0){
            return this.user.clusters[ ( this.user.clusters.length - 1 ) ];
          }
          else return {};

        }
      },
      watch: {
        isEnabled: function(new_val, old_val){
          if( new_val )
            $('.footer-links').addClass('has-rewards-tiers-band');
          else
            $('.footer-links').removeClass('has-rewards-tiers-band');
        }
      }
    }
  </script>


